import { render, staticRenderFns } from "./BatchTables.vue?vue&type=template&id=94af932c&"
import script from "./BatchTables.vue?vue&type=script&lang=js&"
export * from "./BatchTables.vue?vue&type=script&lang=js&"
import style0 from "./BatchTables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports